/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type FeedbackStatus =
  (typeof FeedbackStatus)[keyof typeof FeedbackStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackStatus = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  NEEDS_INFO: "NEEDS_INFO",
  RESOLVED: "RESOLVED",
  REOPENED: "REOPENED",
  REJECTED: "REJECTED",
  CLOSED: "CLOSED",
} as const;
